import Delete from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import {
  Backdrop,
  Button,
  CircularProgress,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  IconButton,
  Link,
  Stack
} from '@mui/material';
import {
  DataGridPro,
  GridColDef,
  GridRowId,
  GridValueFormatterParams,
  GridRenderCellParams,
  GridActionsCellItem
} from '@mui/x-data-grid-pro';
import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { updateUserAccessMessage } from 'src/components/common/AccessMessage';
import { usePermissionWrapper } from 'src/components/common/hooks/usePermissionWrapper';
import { PopupComponent } from 'src/components/common/PopupComponent';
import permissions from 'src/data/permissions.json';
import { AppState, store, useAppSelector } from 'src/store';
import { setDocumentDetail } from 'src/store/documentDetail';
import { setRowDetail } from 'src/store/rowGridData';
import { setSnackbarMessage } from 'src/store/snackbarMessage';
import { setUserDocPermissions } from 'src/store/User';
import { ETMFUI } from 'src/types/KeyCloak';
import { usePreferedDateFormat } from 'src/util/DateFormatter';
import { DocumentUploadListProps } from '../documentViewer/types';
import './DocumentUpload.scss';
import DocManagementService from './service/DocManagementService';
import { CustomPagination } from 'src/util/DataTableFooter';

export const DocumentUploadList = ({
  result,
  setDataGridComponent,
  setDocumentToDisplay,
  setEditDoc,
  handleDialogBox,
  loading,
  setStyleUpload,
  setUploaded,
  documentValue,
  ClearData,
  setFileUploaded,
  isEdited,
  setIsEdited,
  setPage,
  setPageSize,
  pageSize,
  page,
  rowCount
}: DocumentUploadListProps) => {
  const dispatch = useDispatch();
  const [enableDeletePopup, setenableDeletePopup] = useState<boolean>(false);
  const [selectedRowIdDocumentName, setSelectedRowIdDocumentName] = useState('');
  const [fileMasterId, setFileMasterId] = useState('');
  const [tmfDocId, setTmfDocId] = useState('');
  const docService = new DocManagementService();
  const { checkPermission, checkPermissionDocViewLevel } = usePermissionWrapper();
  const { preferedDateFormat, userPreferedDateFormat } = usePreferedDateFormat();
  const user: any = useAppSelector(state => state.user.user);
  const userName = `${user.firstName + ' ' + user.lastName}`;
  const [isProcessing, setProcessing] = useState(false);
  const selectedStudy = useSelector((state: AppState) => state.searchHierarchyDetails?.data[0]?.Study);
  const selectedCountry = useSelector((state: AppState) => state.searchHierarchyDetails?.data[0]?.Country);
  const selectedSite = useSelector((state: AppState) => state.searchHierarchyDetails?.data[0]?.Site);

  let TmfLevel =
    (selectedStudy === '--' || selectedStudy === '') &&
    (selectedCountry === '--' || selectedCountry == '') &&
    (selectedSite === '--' || selectedSite === '')
      ? '--'
      : (selectedCountry === '--' || selectedCountry == '') && (selectedSite === '--' || selectedSite === '')
      ? 'Study'
      : selectedSite === '--' && selectedCountry != '--'
      ? 'Country'
      : 'Site';
  if (TmfLevel === '--') {
    TmfLevel = 'Study';
  }

  const gridFunc = async (documentDetails: any) => {
    /**
     * Bharath
     */
    try {
      const response: any = await docService.getDocAccessPermissions(documentDetails);
      if (response.data != null && response.data.length > 0) {
        const docAccessPermissions: any = response.data.map((item: any) => item.permission);
        dispatch(setUserDocPermissions(docAccessPermissions));
        window.scrollTo(0, 0);
        setDocumentToDisplay(documentDetails);
        setDocumentDetail(dispatch, [documentDetails]);
        setDataGridComponent(false);
      } else {
        updateUserAccessMessage({ status: 403, dispatch: store.dispatch });
      }
    } catch (e: any) {
      updateUserAccessMessage({ status: 403, dispatch: store.dispatch });
    }
  };

  const checkDocLevelActionPermissions = async (documentDetails: any, access: string) => {
    try {
      const response: any = await docService.getDocAccessPermissions(documentDetails);
      if (response.data != null && response.data.length > 0) {
        const docAccessPermissions: any = response.data.map((item: any) => item.permission);
        await dispatch(setUserDocPermissions(docAccessPermissions));
        const found = permissions.access_api.find(item => item.key === access);
        return (
          (found && docAccessPermissions.includes(found.permission as ETMFUI)) || docAccessPermissions.includes('ALL')
        );
      } else {
        return false;
      }
    } catch (e: any) {
      return false;
    }
  };

  const handleEditClick = async (row: any, isEdit: boolean) => {
    // const permission = await checkDocLevelActionPermissions(row, 'update_document_details');
    setRowDetail(dispatch, []);
    const permission = await checkPermission('update_document_details');
    if (permission) {
      const editDoc = {
        row,
        isEdit
      };
      setEditDoc(editDoc);
      setIsEdited(isEdit);
    } else {
      updateUserAccessMessage({ status: 403, dispatch: store.dispatch });
    }
  };

  /**
   * Bharath modification end
   */

  const handleDeleteButtonPopup = (id: GridRowId) => {
    if (isEdited) {
      handleDialogBox();
    } else {
      setenableDeletePopup(true);
      setProcessing(true);
      const deleteSelectedRow = result.filter((item: any) => item.id === id)[0].tmf_document_name;
      const deleteSelectedDocumentId = result.filter((item: any) => item.id === id)[0].tmf_document_id;
      const deleteSelectedfileMasterId = result.filter((item: any) => item.id === id)[0].fmId;
      setSelectedRowIdDocumentName(deleteSelectedRow);
      setTmfDocId(deleteSelectedDocumentId);
      setFileMasterId(deleteSelectedfileMasterId);
      setProcessing(false);
    }
  };

  const handleCloseDeletePopup = () => {
    setenableDeletePopup(false);
  };

  const handleDeleteClick = async () => {
    const deleteSelectedRow = result.filter((item: any) => item.fileId === fileMasterId)[0];
    setProcessing(true);
    // const permission = await checkDocLevelActionPermissions(deleteSelectedRow, 'delete_document');
    const permission = await checkPermission('delete_document');

    if (permission) {
      const deleteDoc: any = {
        deleted_by: userName
      };

      const params = {
        module_section_related: 'DocumentDetails',
        parent_entity_related: '--'
      };
      const response: any = await docService.deleteDocumentDetails(
        fileMasterId,
        tmfDocId,
        deleteDoc,
        selectedStudy,
        selectedCountry,
        selectedSite,
        TmfLevel,
        params
      );
      setProcessing(false);
      if (response.data) {
        store.dispatch(setSnackbarMessage('Document is deleted successfully.', 'success'));
        handleCloseDeletePopup();
      } else {
        store.dispatch(setSnackbarMessage('Error in deleteing document.', 'error'));
      }

      setStyleUpload('uploadFile');
      setFileUploaded(null);
      setUploaded(false);
      documentValue(0, pageSize);
      ClearData();
    } else {
      updateUserAccessMessage({ status: 403, dispatch: store.dispatch });
      handleCloseDeletePopup();
    }
  };

  const columnsGridColDef = () => {
    const columnsData: GridColDef[] = [
      {
        field: 'created_on',
        headerName: 'Uploaded Date',
        width: 200,
        valueFormatter: (params: GridValueFormatterParams) => {
          const valueFormattedDate = String(params.value).split('T')[0].split('-');
          const valueFormattedTime = String(params.value).split('T')[1].split(':');
          const time = valueFormattedTime[0] > '12' ? parseInt(valueFormattedTime[0]) - 12 : valueFormattedTime[0];
          const meridiem = valueFormattedTime[0] > '12' ? 'PM' : 'AM';
          return `${preferedDateFormat(params.value)} at ${time}:${valueFormattedTime[1]} ${meridiem}`;
        }
      },
      {
        field: 'tmf_document_name',
        headerName: 'Document Name',
        renderCell: (params: any) =>
          checkPermission('view_document_details') ? (
            <Link onClick={() => gridFunc(params.row)}>{params.value!.toString()}</Link>
          ) : (
            params.value!.toString()
          ),
        width: 350,
        flex: 1
      },
      { field: 'tmf_artifact_name', headerName: 'Artifact Name', width: 350, flex: 1 },
      { field: 'tmf_doc_status', headerName: 'Status', width: 150 }
    ];

    if (checkPermission('update_document_details') || checkPermission('delete_document')) {
      const actionsColumn = {
        field: 'actions',
        headerName: 'Actions',
        width: 100,
        renderCell: (params: any) => {
          return (
            <div>
              {checkPermission('update_document_details') && (
                <IconButton
                  color="primary"
                  disabled={params.row.tmf_doc_status === 'Approved'}
                  onClick={() => handleEditClick(params.row, true)}
                >
                  <EditIcon />
                </IconButton>
              )}
              {checkPermission('delete_document') && (
                <IconButton color="primary" onClick={() => handleDeleteButtonPopup(params.row.id)}>
                  <Delete />
                </IconButton>
              )}
            </div>
          );
        }
      };
      columnsData.push(actionsColumn);
    }
    return columnsData;
  };

  const columns: GridColDef[] = columnsGridColDef();

  if (isProcessing)
    return (
      <>
        <Backdrop sx={{ color: '#fff', zIndex: theme => theme.zIndex.drawer + 1 }} open={isProcessing}>
          <CircularProgress />
        </Backdrop>
      </>
    );
  return (
    <>
      <div className="mydata-grid-row" style={{ height: 300, width: '100%' }}>
        <h4>Documents</h4>
        <DataGridPro
          rows={result}
          columns={columns}
          rowCount={rowCount}
          page={page}
          onPageChange={newPage => setPage(newPage)}
          pageSize={pageSize}
          onPageSizeChange={newPageSize => setPageSize(newPageSize)}
          rowsPerPageOptions={[5, 10, 20]}
          pagination
          paginationMode="server"
          loading={loading}
          initialState={{
            sorting: {
              sortModel: [{ field: 'created_on', sort: 'desc' }]
            }
          }}
          components={{
            NoRowsOverlay: () => (
              <Stack height="100%" alignItems="center" justifyContent="center">
                No rows
              </Stack>
            ),
            NoResultsOverlay: () => (
              <Stack height="100%" alignItems="center" justifyContent="center">
                No rows
              </Stack>
            ),
            Pagination: CustomPagination
          }}
        />
      </div>
      <React.Fragment>
        <PopupComponent
          open={enableDeletePopup}
          onClose={handleCloseDeletePopup}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
          className="confirm-modal"
        >
          <DialogTitle id="alert-dialog-title">{`Delete Document`}</DialogTitle>
          <DialogContent sx={{ minWidth: 500 }}>
            <DialogContentText id="alert-dialog-description">
              Are you sure you want to delete &quot;<strong>{selectedRowIdDocumentName}</strong>&rdquo;?
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleCloseDeletePopup} autoFocus disabled={isProcessing} className="grey-btn">
              CANCEL
            </Button>
            <Button onClick={() => handleDeleteClick()} autoFocus disabled={isProcessing}>
              Delete
            </Button>
          </DialogActions>
        </PopupComponent>
      </React.Fragment>
    </>
  );
};
